<template>
  <div class="affiliate-detail pk-account-panel">
    <section class="detail-hero">
      <div class="detail-hero-copy">
        <span>合作伙伴账户</span>
        <h1>合作伙伴明细</h1>
        <p>集中查看专属邀请入口、合作用户、收益比例和累计收益记录。</p>
      </div>
      <button @click="goBack">返回合作伙伴计划</button>
    </section>

    <template v-if="loggedIn">
      <section class="partner-access">
        <div class="access-copy">
          <span>专属邀请链接</span>
          <strong>{{ valueUrl || "正在读取专属链接" }}</strong>
        </div>
        <button @click="copyText(valueUrl)">复制链接</button>
        <button class="access-code" @click="copyText(valueCode)">邀请码 {{ valueCode || "-" }}</button>
      </section>

      <section class="detail-summary">
        <article>
          <span>合作用户</span>
          <strong>{{ peopleNum }}</strong>
          <em>已绑定当前账号</em>
        </article>
        <article>
          <span>当前收益比例</span>
          <strong>{{ ratioText }}%</strong>
          <em>按账户当前规则结算</em>
        </article>
        <article>
          <span>累计合作收益</span>
          <strong class="token-value">{{ moneyText(inviteCommission) }} <i></i></strong>
          <em>已进入账户的收益</em>
        </article>
        <article>
          <span>收益记录</span>
          <strong>{{ commissionTotal }}</strong>
          <em>累计结算记录</em>
        </article>
      </section>

      <div class="detail-layout">
        <section class="detail-board">
          <div class="board-head">
            <div>
              <span>合作用户明细</span>
              <strong>已邀请用户</strong>
            </div>
            <em>{{ totalSize }} 人</em>
          </div>

          <div v-if="tableData.length" class="invitee-table-head">
            <span>合作用户</span>
            <span>绑定时间</span>
            <span>绑定方式</span>
            <span>累计充值</span>
          </div>

          <div v-if="tableData.length" class="invitee-list">
            <article v-for="item in tableData" :key="item.id" class="invitee-card">
              <div class="invitee-person">
                <img :src="item.img || defaultAvatar" alt="" @error="useAvatarFallback" />
                <div class="invitee-main">
                  <strong>{{ item.name || `用户 ${item.id}` }}</strong>
                  <span>ID {{ item.id }}</span>
                </div>
              </div>
              <time>{{ item.create_time }}</time>
              <div class="invitee-meta">
                <strong>{{ item.source || "邀请码" }}</strong>
              </div>
              <div class="invitee-money">
                {{ moneyText(item.recharge) }} <i></i>
              </div>
            </article>
          </div>

          <div v-else class="empty-card">
            暂无合作用户。将专属邀请链接或邀请码分享给新用户，绑定关系会显示在这里。
          </div>

          <el-pagination
            v-if="totalSize > pageSize"
            class="detail-page-nav"
            background
            layout="prev, pager, next"
            :total="totalSize"
            :page-size="pageSize"
            @current-change="currentChange"
          ></el-pagination>
        </section>

        <aside class="partner-guide">
          <span>账户说明</span>
          <h2>合作收益如何产生</h2>
          <ol>
            <li><b>01</b><div><strong>分享专属入口</strong><p>发送你的链接或邀请码给新用户。</p></div></li>
            <li><b>02</b><div><strong>用户完成绑定</strong><p>注册时使用专属入口后自动绑定合作关系。</p></div></li>
            <li><b>03</b><div><strong>收益自动入账</strong><p>合作用户完成充值后，按当前比例结算到你的账户。</p></div></li>
          </ol>
          <button @click="goCooperation">联系客服中心</button>
        </aside>
      </div>
    </template>

    <section v-else class="detail-board auth-board">
      <img src="@/assets/hotpizza/hp-case-orange.png" alt="" />
      <div>
        <span>需要登录</span>
        <strong>登录后查看合作伙伴明细</strong>
        <p>专属链接、合作用户、绑定时间和累计收益均与当前账号关联，登录后可查看完整账户明细。</p>
      </div>
      <button @click="openLogin">登录账号</button>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      totalSize: 0,
      page: 1,
      pageSize: 10,
      tableData: [],
      valueUrl: "",
      valueCode: "",
      peopleNum: 0,
      ratio: 0,
      inviteCommission: 0,
      commissionTotal: 0,
      defaultAvatar: require("../assets/img/jiapeople.png"),
    };
  },
  mounted() {
    if (this.loggedIn) {
      this.loadAccount();
    }
  },
  computed: {
    loggedIn() {
      return Boolean(this.$store.state.token || localStorage.getItem("token"));
    },
    ratioText() {
      return Number(this.ratio || 0).toFixed(2).replace(/\.00$/, "");
    },
  },
  watch: {
    loggedIn(value) {
      if (value) {
        this.loadAccount();
      }
    },
  },
  methods: {
    loadAccount() {
      this.getInviteInfo();
      this.getOverview();
      this.getList(1);
    },
    getInviteInfo() {
      this.$axios.post("index/Invite/inviteInfo", this.$qs.stringify({})).then((res) => {
        if (res.data.status == 1) {
          this.valueCode = res.data.data.invite_code;
          this.valueUrl = `${window.location.origin}/index/invite/reg?code=${res.data.data.invite_code}`;
        }
      });
    },
    getOverview() {
      this.$axios
        .post("index/Invite/offline", this.$qs.stringify({ days: 0, page: 1, pageSize: 1 }))
        .then((res) => {
          if (res.data.status == 1) {
            this.peopleNum = res.data.data.people_num;
            this.ratio = res.data.data.ratio;
            this.inviteCommission = res.data.data.invite_commission;
            this.commissionTotal = res.data.data.total;
          }
        });
    },
    getList(page) {
      this.page = page;
      this.$axios
        .post("index/Invite/offlineList", this.$qs.stringify({ page, pageSize: this.pageSize }))
        .then((res) => {
          if (res.data.status == 1) {
            this.totalSize = res.data.data.total;
            this.tableData = res.data.data.list;
          } else {
            this.totalSize = 0;
            this.tableData = [];
          }
        });
    },
    currentChange(val) {
      this.getList(val);
    },
    goBack() {
      this.$router.push({ path: "/Spread" });
    },
    goCooperation() {
      this.$router.push({ path: "/Doubt", query: { category: "cooperation" } });
    },
    openLogin() {
      this.$router.push({ path: "/Login", query: { redirect: this.$route.fullPath } });
    },
    copyText(text) {
      const input = document.createElement("input");
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand("Copy");
      document.body.removeChild(input);
      this.$message({ message: "复制成功", type: "success" });
    },
    moneyText(value) {
      return Number(value || 0).toFixed(2);
    },
    useAvatarFallback(event) {
      event.target.src = this.defaultAvatar;
    },
  },
};
</script>

<style lang="less" scoped>
.affiliate-detail {
  min-height: calc(100vh - 198px);
  padding: 26px 26px 74px;
  color: #f5f7ff;
  background:
    radial-gradient(circle at 44% 0, rgba(255, 138, 31, 0.16), transparent 34%),
    radial-gradient(circle at 86% 24%, rgba(0, 217, 255, 0.1), transparent 28%),
    linear-gradient(180deg, #1d202c 0%, #171923 100%);
}

button {
  font-family: inherit;
}

.detail-hero,
.detail-board {
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;
}

.detail-hero {
  min-height: 250px;
  padding: 38px 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(255, 132, 31, 0.32);
  border-radius: 22px;
  background:
    linear-gradient(135deg, rgba(39, 42, 58, 0.96), rgba(24, 26, 36, 0.98)),
    url("../assets/new/task_bg.png") center / cover;
  box-shadow: 0 28px 80px rgba(0, 0, 0, 0.36);
}

.detail-hero::after {
  content: "";
  width: 560px;
  height: 560px;
  position: absolute;
  right: -180px;
  top: -200px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255, 147, 31, 0.31), transparent 66%);
}

.detail-hero > div,
.detail-hero button {
  position: relative;
  z-index: 1;
}

.detail-hero span,
.board-head span {
  color: #ff8a1f;
  font-size: 13px;
  font-weight: 900;
  letter-spacing: 0.16em;
}

.detail-hero h1 {
  margin: 12px 0 16px;
  font-size: 54px;
  line-height: 1;
  font-weight: 1000;
}

.detail-hero p {
  max-width: 620px;
  color: #aeb6c8;
  font-size: 17px;
  line-height: 1.8;
}

.detail-hero button {
  height: 44px;
  padding: 0 22px;
  color: #151620;
  background: linear-gradient(180deg, #ffcb28, #ff8a00);
  border: 0;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 1000;
  cursor: pointer;
  box-shadow: 0 12px 28px rgba(241, 107, 0, 0.22);
}

.detail-board {
  margin-top: 18px;
  padding: 22px;
  background: linear-gradient(180deg, rgba(43, 45, 59, 0.95), rgba(31, 33, 45, 0.98));
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 12px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.22), inset 0 1px 0 rgba(255, 255, 255, 0.035);
}

.board-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
}

.board-head strong {
  display: block;
  margin-top: 8px;
  color: #f4f7ff;
  font-size: 22px;
  font-weight: 1000;
}

.board-head em {
  color: #ffd764;
  font-size: 24px;
  font-style: normal;
  font-weight: 1000;
}

.invitee-list {
  margin-top: 18px;
  display: grid;
  gap: 10px;
}

.invitee-card,
.empty-card {
  background: rgba(255, 255, 255, 0.035);
  border: 1px solid rgba(255, 255, 255, 0.055);
  border-radius: 10px;
}

.invitee-card {
  min-height: 90px;
  padding: 14px 16px;
  display: grid;
  grid-template-columns: 58px 1fr 170px 130px;
  gap: 16px;
  align-items: center;
}

.invitee-card img {
  width: 58px;
  height: 58px;
  border-radius: 50%;
  object-fit: cover;
}

.invitee-main strong,
.invitee-meta strong {
  display: block;
  color: #f4f7ff;
  font-size: 16px;
  font-weight: 1000;
}

.invitee-main span,
.invitee-meta span {
  display: block;
  margin-top: 6px;
  color: #9aa3b8;
  font-size: 13px;
  font-weight: 900;
}

.invitee-money {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 7px;
  color: #ffd764;
  font-size: 21px;
  font-weight: 1000;
}

.invitee-money i {
  width: 18px;
  height: 18px;
  display: inline-block;
  background: url("../assets/pizzaking/pizza-token.svg") center / contain no-repeat;
}

.empty-card {
  margin-top: 18px;
  padding: 34px 18px;
  color: #929bad;
  text-align: center;
  font-size: 14px;
  font-weight: 800;
}

.auth-board {
  min-height: 250px;
  display: grid;
  grid-template-columns: 190px minmax(0, 1fr) auto;
  gap: 24px;
  align-items: center;
  background:
    radial-gradient(circle at 12% 50%, rgba(255, 138, 31, 0.24), transparent 34%),
    linear-gradient(180deg, rgba(43, 45, 59, 0.95), rgba(31, 33, 45, 0.98));
  border-color: rgba(255, 132, 31, 0.24);
}

.auth-board img {
  width: 180px;
  max-height: 150px;
  object-fit: contain;
  filter: drop-shadow(0 20px 28px rgba(255, 138, 31, 0.22));
}

.auth-board span {
  color: #ff8a1f;
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0.18em;
}

.auth-board strong {
  display: block;
  margin-top: 8px;
  color: #fbfcff;
  font-size: 30px;
  font-weight: 1000;
}

.auth-board p {
  max-width: 560px;
  margin: 10px 0 0;
  color: #aeb7c8;
  font-size: 15px;
  line-height: 1.7;
  font-weight: 800;
}

.auth-board button {
  height: 44px;
  padding: 0 24px;
  color: #151620;
  background: linear-gradient(180deg, #ffd53b, #ff8300);
  border: 0;
  border-radius: 8px;
  font-weight: 1000;
  cursor: pointer;
  box-shadow: 0 14px 34px rgba(255, 131, 0, 0.24);
}

.detail-page-nav {
  margin-top: 16px;
  text-align: right;
}

.detail-page-nav /deep/ .el-pager li:not(.disabled).active {
  color: #151620;
  background: #ffae1d;
}

.detail-page-nav /deep/ .el-pagination.is-background .btn-next,
.detail-page-nav /deep/ .el-pagination.is-background .btn-prev,
.detail-page-nav /deep/ .el-pagination.is-background .el-pager li {
  color: #aab3c6;
  background: #242735;
}

@media screen and (max-width: 920px) {
  .affiliate-detail {
    padding: 18px 12px 58px;
  }

  .detail-hero {
    display: block;
    padding: 30px 22px;
  }

  .detail-hero h1 {
    font-size: 42px;
  }

  .detail-hero button {
    margin-top: 20px;
  }

  .invitee-card {
    grid-template-columns: 1fr;
  }

  .auth-board {
    grid-template-columns: 1fr;
  }

  .invitee-money {
    justify-content: flex-start;
  }
}
</style>

<style lang="less" scoped>
.affiliate-detail.pk-account-panel {
  padding: 28px 28px 96px !important;
}

.affiliate-detail.pk-account-panel .detail-hero,
.partner-access,
.detail-summary,
.detail-layout {
  width: calc(100% - 24px) !important;
  max-width: 1540px !important;
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;
}

.affiliate-detail.pk-account-panel .detail-hero {
  min-height: 224px !important;
  padding: 36px 44px !important;
  background:
    radial-gradient(circle at 82% 50%, rgba(255, 144, 29, 0.22), transparent 300px),
    linear-gradient(118deg, #252734, #1e202b) !important;
}

.detail-hero-copy {
  max-width: 680px;
}

.partner-access {
  min-height: 92px;
  margin-top: 18px;
  padding: 16px 18px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto auto;
  gap: 10px;
  align-items: center;
  border: 1px solid #303342;
  border-radius: 8px;
  background: #20222f;
}

.access-copy {
  min-width: 0;
}

.access-copy span,
.detail-summary span,
.partner-guide > span {
  display: block;
  color: #ff9b22;
  font-size: 11px;
  font-weight: 900;
  letter-spacing: 0.14em;
}

.access-copy strong {
  max-width: 100%;
  margin-top: 8px;
  display: block;
  overflow: hidden;
  color: #f3f5fc;
  font-size: 14px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.partner-access button,
.partner-guide button {
  height: 42px;
  padding: 0 19px;
  color: #211307;
  border: 0;
  border-radius: 6px;
  background: linear-gradient(180deg, #ffd057, #ff870e);
  font-weight: 1000;
  cursor: pointer;
}

.partner-access .access-code {
  color: #f1f3fa;
  border: 1px solid #3a3e4e;
  background: #2a2d3a;
}

.detail-summary {
  margin-top: 12px;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}

.detail-summary article {
  min-height: 116px;
  padding: 20px;
  border: 1px solid #2f3241;
  border-radius: 8px;
  background: #20222f;
}

.detail-summary strong {
  min-height: 36px;
  margin-top: 9px;
  display: flex;
  align-items: center;
  gap: 7px;
  color: #f7f8fc;
  font-size: 27px;
  font-weight: 1000;
}

.detail-summary em {
  display: block;
  margin-top: 5px;
  color: #7f8799;
  font-size: 12px;
  font-style: normal;
}

.token-value i,
.invitee-money i {
  width: 18px;
  height: 18px;
  display: inline-block;
  flex: 0 0 auto;
  background: url("../assets/pizzaking/pizza-token.svg") center / contain no-repeat;
}

.detail-layout {
  margin-top: 12px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 320px;
  gap: 12px;
  align-items: start;
}

.affiliate-detail.pk-account-panel .detail-layout .detail-board {
  width: 100% !important;
  max-width: none !important;
  margin: 0 !important;
  padding: 22px !important;
  box-sizing: border-box;
}

.invitee-table-head,
.affiliate-detail.pk-account-panel .invitee-card {
  display: grid;
  grid-template-columns: minmax(260px, 1.5fr) 190px 130px 150px !important;
  gap: 16px;
  align-items: center;
}

.invitee-table-head {
  min-height: 42px;
  margin-top: 18px;
  padding: 0 16px;
  color: #777f91;
  border-bottom: 1px solid #303342;
  font-size: 11px;
  font-weight: 900;
  letter-spacing: 0.08em;
}

.affiliate-detail.pk-account-panel .invitee-list {
  margin-top: 0;
}

.affiliate-detail.pk-account-panel .invitee-card {
  min-height: 86px !important;
  padding: 12px 16px;
  border: 0 !important;
  border-bottom: 1px solid #2d303e !important;
  border-radius: 0 !important;
  background: transparent !important;
}

.invitee-person {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 12px;
}

.affiliate-detail.pk-account-panel .invitee-card img {
  width: 48px !important;
  height: 48px !important;
  flex: 0 0 auto;
}

.invitee-main {
  min-width: 0;
}

.invitee-main strong {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.invitee-card time {
  color: #9ba3b4;
  font-size: 13px;
  font-weight: 800;
}

.invitee-meta strong {
  color: #c8cedb;
  font-size: 13px;
}

.partner-guide {
  padding: 24px;
  border: 1px solid rgba(255, 147, 35, 0.28);
  border-radius: 8px;
  background:
    radial-gradient(circle at 100% 0, rgba(255, 137, 19, 0.17), transparent 210px),
    #20222f;
}

.partner-guide h2 {
  margin: 8px 0 22px;
  color: #f4f2ec;
  font-size: 23px;
}

.partner-guide ol {
  margin: 0;
  padding: 0;
  list-style: none;
}

.partner-guide li {
  padding: 15px 0;
  display: grid;
  grid-template-columns: 42px minmax(0, 1fr);
  gap: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.partner-guide li > b {
  color: #ff9b22;
  font-size: 13px;
}

.partner-guide li strong {
  color: #edf0f7;
  font-size: 14px;
}

.partner-guide li p {
  margin: 5px 0 0;
  color: #8f98aa;
  font-size: 12px;
  line-height: 1.55;
}

.partner-guide button {
  width: 100%;
  margin-top: 16px;
}

@media screen and (max-width: 1180px) {
  .detail-layout {
    grid-template-columns: 1fr;
  }

  .invitee-table-head,
  .affiliate-detail.pk-account-panel .invitee-card {
    grid-template-columns: minmax(220px, 1fr) 170px 110px 130px !important;
  }
}

@media screen and (max-width: 920px) {
  .affiliate-detail.pk-account-panel {
    padding: 16px 12px 88px !important;
  }

  .affiliate-detail.pk-account-panel .detail-hero,
  .partner-access,
  .detail-summary,
  .detail-layout {
    width: 100% !important;
  }

  .affiliate-detail.pk-account-panel .detail-hero {
    min-height: 0 !important;
    padding: 28px 22px !important;
  }

  .partner-access {
    grid-template-columns: 1fr 1fr;
  }

  .access-copy {
    grid-column: 1 / -1;
  }

  .detail-summary {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .invitee-table-head {
    display: none;
  }

  .affiliate-detail.pk-account-panel .invitee-list {
    margin-top: 16px;
  }

  .affiliate-detail.pk-account-panel .invitee-card {
    grid-template-columns: 1fr auto !important;
    gap: 10px 14px;
  }

  .invitee-person {
    grid-column: 1 / -1;
  }

  .invitee-card time {
    grid-column: 1;
  }

  .invitee-meta {
    grid-column: 2;
    text-align: right;
  }

  .invitee-money {
    grid-column: 1 / -1;
    justify-content: flex-start;
  }
}

@media screen and (max-width: 520px) {
  .affiliate-detail.pk-account-panel .detail-hero h1 {
    font-size: 36px;
  }

  .affiliate-detail.pk-account-panel .detail-hero button {
    width: 100%;
  }

  .partner-access,
  .detail-summary {
    grid-template-columns: 1fr;
  }

  .access-copy {
    grid-column: auto;
  }

  .detail-summary article {
    min-height: 102px;
  }

  .affiliate-detail.pk-account-panel .detail-layout .detail-board,
  .partner-guide {
    padding: 16px !important;
  }
}
</style>
